/** PM tool (staff) is served only on this host in production. */
export const PM_TOOL_ORIGIN = 'https://pm-tool.manedesign.in';

const PM_TOOL_HOSTS = new Set(['pm-tool.manedesign.in']);

const PUBLIC_SITE_HOSTS = new Set(['manedesign.in', 'www.manedesign.in']);

export function getHostname(): string {
  return window.location.hostname.toLowerCase();
}

/** Staff PM routes and /login are allowed on this host. */
export function isPmToolHost(): boolean {
  const host = getHostname();
  if (PM_TOOL_HOSTS.has(host)) return true;
  // Local dev: same origin serves both portal and PM tool unless simulating public site.
  if (import.meta.env.DEV && (host === 'localhost' || host === '127.0.0.1')) {
    return import.meta.env.VITE_PUBLIC_SITE !== 'true';
  }
  return false;
}

export function isPublicSiteHost(): boolean {
  const host = getHostname();
  if (PUBLIC_SITE_HOSTS.has(host)) return true;
  if (import.meta.env.DEV && (host === 'localhost' || host === '127.0.0.1')) {
    return import.meta.env.VITE_PUBLIC_SITE === 'true';
  }
  return false;
}

export function pmToolUrl(path = '/'): string {
  const normalized = path.startsWith('/') ? path : `/${path}`;
  if (isPmToolHost()) return normalized;
  return `${PM_TOOL_ORIGIN}${normalized}`;
}

/** Send staff users to the PM tool domain when they land on the public marketing site. */
export function redirectStaffToPmTool(path = '/dashboard'): void {
  window.location.replace(pmToolUrl(path));
}
